export default "__VITE_ASSET__D4OMUd1y__"